import React from 'react';
import { useTranslations } from 'next-intl';
import DetailsTile from '@/ui/components/shared/DetailsTile';
import DetailsTileHeading from '@/ui/components/shared/DetailsTileHeading';
import OrderAddress from '@/ui/components/shared/order-details/OrderAddress/OrderAddress';

type Address = React.ComponentProps<typeof OrderAddress>;

interface OrderAddressesProps {
  shipping?: Address;
  billing?: Address;
  /** Optional title overrides; default to the OrderAddresses translations when omitted. */
  shippingTitle?: string;
  billingTitle?: string;
}

/**
 * The shipping + billing address card shared by the account order-detail view and the order
 * confirmation delivery-info tile. Titles default to the shared OrderAddresses translations; callers
 * can still override them.
 */
export function OrderAddresses({
  shipping,
  billing,
  shippingTitle,
  billingTitle,
}: Readonly<OrderAddressesProps>) {
  const t = useTranslations('OrderAddresses');

  return (
    <DetailsTile className="space-y-6">
      <div>
        <DetailsTileHeading heading={shippingTitle ?? t('shippingTitle')} />
        <OrderAddress {...(shipping ?? {})} />
      </div>
      <div>
        <DetailsTileHeading heading={billingTitle ?? t('billingTitle')} />
        <OrderAddress {...(billing ?? {})} />
      </div>
    </DetailsTile>
  );
}
